import Anchor from "atoms/anchors/anchor";
import React from "react";
import LinkResourceRecord from "./link-resource-record";
import { LinkResourceStyle } from "./link-resource-styles";

interface ILinkResourcesRequiredProps {
    linkResourceRecords: LinkResourceRecord[];
}

interface ILinkResourcesOptionalProps {
    linkResourceStyles?: LinkResourceStyle;
    onNavItemClick?: () => void;
    isPublic?: boolean;
}

interface LinkResourcesProps
    extends ILinkResourcesRequiredProps,
        ILinkResourcesOptionalProps {}

const LinkResources: React.FunctionComponent<LinkResourcesProps> = (
    props: LinkResourcesProps
) => {
    const {
        linkResourceRecords,
        linkResourceStyles = LinkResourceStyle.Default,
        onNavItemClick = () => null,
        isPublic = false,
    } = props;
    const cssBase = "c-link-resources";
    const cssClass = `${cssBase}${linkResourceStyles}`;

    return (
        <nav className={cssClass}>
            <h3 className={`${cssClass}__header`}>LiNK Resources</h3>
            {linkResourceRecords.map(
                (linkResourceRecord: LinkResourceRecord) => {
                    return (
                        <Anchor
                            cssClassName={`${cssClass}__link`}
                            key={linkResourceRecord.title}
                            onClick={onNavItemClick}
                            disabled={isPublic}
                            to={linkResourceRecord.link}>
                            <div className={`${cssClass}__item`}>
                                {linkResourceRecord.title}
                            </div>
                        </Anchor>
                    );
                }
            )}
        </nav>
    );
};
export default LinkResources;
